<template>
  <div>
    <!-- search input -->
    <div>
      <b-card title="Partner Attempt">
        <b-row class="mb-1">
          <!-- search input -->
          <b-col>
            <section>
              <b-button
                v-b-modal.modal-filter-orders
                variant="outline-primary"
                class="d-flex"
              >
                <feather-icon icon="FilterIcon" />Filter
              </b-button>
            </section>
          </b-col>
          <b-col>
            <b-form-group
              v-if="dataFiltered == true"
              class="d-flex justify-content-center"
            >
              <!-- search input -->
              <div>
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  placeholder="search"
                />
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="dataFiltered === true"
            class="d-flex justify-content-end"
          >
            <xlsx-workbook>
              <xlsx-sheet
                v-for="sheet in sheets"
                :key="sheet.name"
                :collection="sheet.data"
                :sheet-name="sheet.name"
              />
              <xlsx-download>
                <b-button variant="primary" class="d-flex">
                  <feather-icon icon="DownloadCloudIcon" /> Export
                </b-button>
              </xlsx-download>
            </xlsx-workbook>
          </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table
          :columns="this.setpartnerAttempt === 0 ? columns : columns2"
          :rows="orderTransactionHistories"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <b-row>
          <b-col>
            <b-modal
              id="modal-filter-orders"
              title="Partner Approval Attempt"
              ok-title="Search"
              cancel-variant="outline-secondary"
              size="lg"
              @ok="filterOrders"
            >
              <b-form>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Merchants option"
                      label-for="Merchants"
                    >
                      <v-select
                        multiple
                        v-model="selected"
                        :options="merchants"
                        label="name"
                      >
                        <template #option="option">
                          <span>{{ option.name }}</span>
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Partner Attempt"
                      label-for="partner-attempt"
                    >
                      <b-form-select
                        id="partner-attempt"
                        v-model="setpartnerAttempt"
                        :options="partnerAttempt"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Payment option"
                      label-for="payment-option"
                    >
                      <b-form-select
                        id="payment-option"
                        v-model="filterFopId"
                        :options="paymentOptions"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Order Date Range"
                      label-for="order-date-range"
                    >
                      <flat-pickr
                        v-model="trxnDateRange"
                        class="form-control"
                        :config="{ mode: 'range', maxDate: 'today' }"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </b-col>
        </b-row>

        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    vSelect,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      merchantIds: "",
      selected: [],
      merchants: [],
      pageLength: 5,
      rangeDate: null,
      trxnDateRange: "",
      trxnStartDate: "",
      trxnEndDate: "",
      filterFopId: 0,
      columns: [
        {
          label: "Order Date",
          field: "orderDate",
        },
        {
          label: "Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order ID",
          field: "orderCode",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Vendor Txn RefNumber",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Payment Option",
          field: "paymentOptionDescription",
        },
        {
          label: "Expiry Date",
          field: "expiryDate",
        },
        {
          label: "First Attempt Date ",
          field: "firstAttemptDate",
        },
        {
          label: "Last Attempt Date ",
          field: "lastTransacrionAttemptDate",
        },
        {
          label: "Attempt",
          field: "numberOfAttempt",
        },
        {
          label: "Response Message",
          field: "responseMessage",
        },
      ],
      columns2: [
        {
          label: "Order Date",
          field: "orderDate",
        },
        {
          label: "Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order ID",
          field: "orderCode",
        },
        {
          label: "Payment Option",
          field: "paymentOptionDescription",
        },
        {
          label: "Status Description",
          field: "statusDescription",
        },
        {
          label: "Expiry Date",
          field: "expiryDate",
        },
        {
          label: "First Attempt Date ",
          field: "firstAttemptDate",
        },
        {
          label: "Last Attempt Date ",
          field: "lastTransacrionAttemptDate",
        },
        {
          label: "Attempt",
          field: "numberOfAttempt",
        },
      ],
      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],
      partnerAttempt: [
        {
          value: 0,
          text: "Confirm Order Attempt",
        },
        {
          value: 1,
          text: "Get Order Attempt",
        },
      ],
      setpartnerAttempt: 0,
      orderTransactionHistories: [],
      summary: [],
      sheets: [{ name: "Detail Transactions", data: [] }],
      searchTerm: "",
      url: "",
    };
  },
  created() {
    this.fetchallPaymentOptions();
    this.fetchMerchant();
  },
  methods: {
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.merchants = res.merchants;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      this.setpartnerAttempt === 0
        ? (this.url = `/Order/api/V1.0/Report/GetPartnerApprovalAttemptReport?paymentOptionId=${this.filterFopId}&transactionStartDate=${this.trxnStartDate}&transactionEndDate=${this.trxnEndDate}&merchantIds=${this.merchantIds}`)
        : (this.url = `/Order/api/V1.0/Report/GetPartnersGetOrderAttemptReport?paymentOptionId=${this.filterFopId}&transactionStartDate=${this.trxnStartDate}&transactionEndDate=${this.trxnEndDate}&merchantIds=${this.merchantIds}`);

      // Api call
      this.isLoading = true;
      axios
        .get(this.url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.orderTransactionHistories =
            res.partenerAttemptTransactionHistories;
          this.setpartnerAttempt === 0
            ? res.partenerAttemptTransactionHistories.map((f) => {
                this.sheets[0].data.push({
                  OrderDate: f.orderDate,
                  OrderCode: f.customOrderCode,
                  OrderID: f.orderCode,
                  Amount: f.amount,
                  VendorTxnRefNumber: f.vendorTxnRefNumber,
                  PaymentOption: f.paymentOptionDescription,
                  ExpiryDate: f.expiryDate,
                  Paid_Payment_Option: f.paymentOptionDescription,
                  FirstAttemptDate: f.firstAttemptDate,
                  LastAttemptDate: f.lastTransacrionAttemptDate,
                  Attempt: f.numberOfAttempt,
                  ResponseMessage: f.responseMessage,
                });
              })
            : res.partenerAttemptTransactionHistories.map((f) => {
                this.sheets[0].data.push({
                  OrderDate: f.orderDate,
                  OrderCode: f.customOrderCode,
                  OrderID: f.orderCode,
                  PaymentOption: f.paymentOptionDescription,
                  StatusDescription: f.statusDescription,
                  ExpiryDate: f.expiryDate,
                  Paid_Payment_Option: f.paymentOptionDescription,
                  FirstAttemptDate: f.firstAttemptDate,
                  LastAttemptDate: f.lastTransacrionAttemptDate,
                  Attempt: f.numberOfAttempt,
                });
              });
          this.isLoading = false;
          this.merchantIds = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.orderTransactionHistories = [];
          console.log(res);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.merchantIds = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
